import React from "react";

export default function DateFilter({ startDate, endDate, onStartChange, onEndChange, onApply, onClear }) {
  return (
    <div className="stripe-filter-bar">
      <input
        type="date"
        value={startDate}
        onChange={(e) => onStartChange(e.target.value)}
      />
      <span className="stripe-filter-sep">to</span>
      <input
        type="date"
        value={endDate}
        onChange={(e) => onEndChange(e.target.value)}
      />
      <button className="stripe-btn-apply" onClick={onApply}>Apply</button>
      <button className="stripe-btn-clear" onClick={onClear}>Clear</button>
    </div>
  );
}
